import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { hasFeatureAccess, FEATURES } from '../../config/roleFeatures';
import SalesHeader from './components/SalesHeader';
import SalesMetrics from './components/SalesMetrics';
import SalesFilters from './components/SalesFilters';
import SalesTable from './components/SalesTable';
import { useSalesData } from './hooks/useSalesData';
import { useSalesFilters } from './hooks/useSalesFilters';

const Sales = () => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const userRole = user?.admin_role?.toUpperCase();
  
  const [showProfits, setShowProfits] = useState(false);
  const [showTotalSale, setShowTotalSale] = useState(false);
  
  
  // Get filters first
  const {
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    dateFilter,
    setDateFilter,
    setCustomDateRange,
    creatorFilter,
    setCreatorFilter,
    // page,
    setPage,
    apiFilters,
    clearFilters
  } = useSalesFilters();
  
  // Use filters in sales data hook
  const { 
    sales, 
    creators,
    pagination,
    metrics, 
    loading, 
    error,
    deleteSale,
    updateSaleStatus,
    // cancelSale,
    refreshData
  } = useSalesData(apiFilters);

  const handleViewInvoice = (sale) => {
    navigate(`/sales/view/${sale.id}`);
  };

  const handlePrintInvoice = (sale) => {
    navigate(`/sales/print/${sale.id}`);
  };

  const handleDeleteSale = async (saleId) => {
    await deleteSale(saleId);
  };

  return (
    <div className="sales-container">
      <SalesHeader />
      
      {hasFeatureAccess(userRole, FEATURES.SALES_METRICS) && (
        <SalesMetrics 
          metrics={metrics} 
          showProfits={showProfits} 
          setShowProfits={setShowProfits}
          showTotalSale={showTotalSale}
          setShowTotalSale={setShowTotalSale}
        />
      )}
      
      <SalesFilters
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        statusFilter={statusFilter}
        onStatusChange={setStatusFilter}
        dateFilter={dateFilter}
        onDateChange={setDateFilter}
        onCustomDateSelect={setCustomDateRange}
        creatorFilter={creatorFilter}
        onCreatorChange={setCreatorFilter}
        onClearFilters={clearFilters}
        creators={creators}
      />
      
      <SalesTable
        sales={sales}
        loading={loading}
        pagination={pagination}
        onPageChange={setPage}
        onViewInvoice={handleViewInvoice}
        onPrintInvoice={handlePrintInvoice}
        onDeleteSale={handleDeleteSale}
        onUpdateStatus={updateSaleStatus}
        showProfits={showProfits}
        showTotalSale={showTotalSale}
      />
      
      {error && (
        <div className="sales-error">
          <p>Error loading sales data: {error}</p>
          <button onClick={refreshData} className="retry-btn">
            Retry
          </button>
        </div>
      )}


    </div>
  );
};

export default Sales;